"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var PlanOption = (0, _styledComponents.default)(_UISelectableBox.default).withConfig({
  displayName: "PlanButton__PlanOption",
  componentId: "sc-16yycvu-0"
})(["&&&{border-radius:0;margin:0;flex:1;padding:10px;align-self:stretch;display:flex;justify-content:center;align-items:center;height:92px;width:100%;}"]);

var PlanText = _styledComponents.default.div.withConfig({
  displayName: "PlanButton__PlanText",
  componentId: "sc-16yycvu-1"
})(["font-size:14px;"]);

var Plan = _styledComponents.default.div.withConfig({
  displayName: "PlanButton__Plan",
  componentId: "sc-16yycvu-2"
})(["font-weight:600;"]);

function PlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition,
      selected = _ref.selected,
      onSelectedChange = _ref.onSelectedChange;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);
  var price = calculatePriceAndItemConfig({
    merchandiseId: merchandiseId
  }).monthly.calculatedPrice;
  return _react.default.createElement(PlanOption, {
    selected: selected,
    onSelectedChange: onSelectedChange,
    "data-selected": selected,
    "data-selenium-class": "plan-button-" + edition
  }, _react.default.createElement(PlanText, null, _react.default.createElement(Plan, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.edition." + edition
  })), _react.default.createElement("div", null, _react.default.createElement(_PriceDisplay.default, {
    price: price,
    currencyCode: currencyCode
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonthFull"
  }))));
}

var _default = PlanButton;
exports.default = _default;
module.exports = exports.default;